export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1591377852/general/cflogo_black.png'
export const homebg = ''
export const about = 'https://dmoiux8hc981g.cloudfront.net/about.webp'
export const contactbg = 'https://dmoiux8hc981g.cloudfront.net/contactbg.webp'
export const foodGallery =
  'https://dmoiux8hc981g.cloudfront.net/foodGallery.webp'
export const hero = 'https://dmoiux8hc981g.cloudfront.net/hero.jpg'
export const heroText = 'https://dmoiux8hc981g.cloudfront.net/heroText.webp'
export const locationMap =
  'https://dmoiux8hc981g.cloudfront.net/locationMap.webp'
export const logo = 'https://dmoiux8hc981g.cloudfront.net/logo.webp'
export const logoTitle = 'https://dmoiux8hc981g.cloudfront.net/logoTitle.png'
export const mobileAbout =
  'https://dmoiux8hc981g.cloudfront.net/mobileAbout.webp'
export const mobileContactbg =
  'https://dmoiux8hc981g.cloudfront.net/mobileContact.webp'
export const mobileHero =
  'https://dmoiux8hc981g.cloudfront.net/mobileHero3.webp'
export const mobileLogo =
  'https://dmoiux8hc981g.cloudfront.net/mobileLogo2.webp'
export const mobileHeroText =
  'https://dmoiux8hc981g.cloudfront.net/mobileHeroText.webp'
export const mobileGallery1 = 'https://dmoiux8hc981g.cloudfront.net/menu1.webp'
export const mobileGallery2 = 'https://dmoiux8hc981g.cloudfront.net/menu2.webp'
export const mobileGallery3 = 'https://dmoiux8hc981g.cloudfront.net/menu3.webp'
export const mobileMap = 'https://dmoiux8hc981g.cloudfront.net/mobileMap.webp'
export const mobilePromotion =
  'https://dmoiux8hc981g.cloudfront.net/mobilePromo.webp'
export const orderPickupButton =
  'https://dmoiux8hc981g.cloudfront.net/orderButton.webp'
export const promotions = 'https://dmoiux8hc981g.cloudfront.net/promo2.webp'
export const menu2 = 'https://dmoiux8hc981g.cloudfront.net/foodGalleryAdd.webp'
export const mobileMenu2 =
  'https://dmoiux8hc981g.cloudfront.net/mobileMenu2.webp'
